const footer = document.querySelector('#site-footer');

function Position(obj){
    var currenttop = 0;
    if (obj.offsetParent){
        do{
            currenttop += obj.offsetTop;
        }while ((obj = obj.offsetParent));
        return [currenttop];
    }
}

if(document.querySelector('.gform_confirmation_wrapper ')) { // If form submitted successfully
    // setTimeout(() => {
        if(document.querySelector('.gform_confirmation_message')) { // If form submitted successfully
            //console.log('lol')

            //console.log('form submitted');
            document.body.classList.add('form-open');
            footer.classList.add('card-open');


        }
        else {
            //console.log('form not submitted');
        }
    // }, 1000);
}



if (document.querySelector('div.gravity-theme')) {


    if(document.querySelector('.gfield_validation_message')) { // If there are validation errors
        // footer.classList.add('card-open');
        document.body.classList.add('form-open');
        let emailInput = document.querySelector('.ginput_container_email');
        let emailField = emailInput.parentNode;
        emailField.classList.add('changed');
    }

    const form = document.querySelector('.contact-form .gravity-theme');

    form.querySelectorAll('.gfield').forEach((formField) => {

        // console.log(formField);
        let options = {
                childList: true,
                subtree:true
            },

            observer = new MutationObserver(mCallback);

        function mCallback(mutations) { // Mutation observer to listen for validation messages in child
            for (let mutation of mutations) {
                if (mutation.type === 'childList') {

                    if (mutation.target.parentNode.querySelector('.wpcf7-not-valid-tip')){
                        mutation.target.parentNode.classList.add('invalid'); // Add invalid class to parent

                        mutation.target.querySelector('input').focus(); //Focus on input with error
                        let fieldName = mutation.target.querySelector('input').getAttribute('name'); //Get field name
                        mutation.target.querySelector('.wpcf7-not-valid-tip').setAttribute('id', "error-"+fieldName); //Use field name to add ID to error message
                        mutation.target.querySelector('input').setAttribute('aria-describedby', "error-"+fieldName); // aria describedby to error
                    }
                }
            }
        }

        observer.observe(formField, options);

        let input = null;

        if (formField.querySelector('input')) {
            input = formField.querySelector('input');
        }

        if (formField.querySelector('textarea')) {
            input = formField.querySelector('textarea');
        }

        if (input) {

            input.addEventListener('change', () => {
                inputChange();
                if (input.value === '') {
                    inputReset();
                }
            });

            function inputChange() {
                formField.classList.add('changed');
            }

            function inputReset() {
                formField.classList.remove('changed');
            }

            input.addEventListener('change', () => {
                inputChange();
                if (input.value === '') {
                    inputReset();
                }
            });

            input.addEventListener('focusin', inputChange);
            input.addEventListener('focusout', () => {

                if (!formField.querySelector('.wpcf7-not-valid-tip')) { // Get rid of invalid styles
                    formField.classList.remove('invalid')
                }

                if (input.value === '') {
                    inputReset();
                }
            });
        }
    });

}
